import { render, staticRenderFns } from "./UserPendingInvites.vue?vue&type=template&id=63576464&scoped=true&"
import script from "./UserPendingInvites.vue?vue&type=script&lang=js&"
export * from "./UserPendingInvites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63576464",
  null
  
)

export default component.exports